import { handleActions } from 'redux-actions';
import _ from 'lodash';

export default handleActions({
  // TODO: Clean up articles with old tags that are capitalized and remove the filtering here
  LOAD_TAG_VALUES: (state, { payload }) => _.uniq(payload.data.map(type => type.tag.toLowerCase())),
}, []);



// WEBPACK FOOTER //
// ./src/reducer/tagValues.js